import NiceModal from '@ebay/nice-modal-react';
import { Box } from '@mantine/core';

import { useGetServices } from '../api/getServices';

import { AddModal } from './AddModal';
import { ServicesTable } from './Table';

import { AddButton, ListLoader } from '@/components';
import { Departments } from '@/types';

type ServicesListProps = {
  department: Departments;
};

export const ServicesList = ({ department }: ServicesListProps) => {
  const { data, isLoading } = useGetServices({ department });

  if (isLoading) {
    return <ListLoader />;
  }

  if (!data?.services.length) {
    return <ListAddButton department={department} />;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <ServicesTable department={department} services={data.services} />
      </Box>
      <ListAddButton department={department} />
    </Box>
  );
};

function ListAddButton({ department }: { department: Departments }) {
  return (
    <AddButton
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            department,
            name: '',
            key: '',
          },
        })
      }
    />
  );
}
